import Navbar from '@/pages/home/components/Navbar';
import AboutUs from '@/pages/home/components/AboutUs';
import Footer from '@/pages/home/components/Footer';
import PageHero from '@/components/feature/PageHero';
import PageTransition from '@/components/feature/PageTransition';
import PageCrossLink from '@/components/feature/PageCrossLink';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: 'About Higher Standard Global',
  url: `${siteUrl}/about`,
  description:
    'A private property management firm built on discretion, precision, and an uncompromising standard of care for the properties we manage.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Higher Standard Global',
    url: siteUrl,
    description:
      'Higher Standard Global is a premium rental property management firm serving select clientele by referral only.',
    foundingDate: '2018',
    areaServed: 'Worldwide',
  },
};

export default function AboutPage() {
  useSEO({
    title: 'About Us | Higher Standard Global — Premium Property Management',
    description:
      'A private property management firm built on discretion, precision, and an uncompromising standard of care. Higher Standard Global serves select clientele by referral only.',
    keywords: 'about Higher Standard Global, property management firm, private real estate management, referral only property management',
    canonical: '/about',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={aboutSchema} id="schema-about" />
      <Navbar />
      <PageHero
        eyebrow="Higher Standard Global"
        title="About Us"
        subtitle="A private firm built on discretion, precision, and an uncompromising standard of care for the properties we manage."
        imageUrl="https://public.readdy.ai/ai/img_res/95ba07dc23981e90c6954dd5fc0e6511.jpg"
        ctaLabel="Request an Introduction"
        ctaPath="/contact"
      />
      <PageTransition label="Our Firm" />
      <AboutUs />
      <PageCrossLink
        next={{
          label: 'Philosophy',
          eyebrow: 'Our Guiding Principles',
          description: 'Understand the values and long-view thinking that shape every decision we make.',
          path: '/philosophy',
        }}
      />
      <Footer />
    </main>
  );
}
